const openSelect = (e) => {
  const openItem = e.currentTarget.parentNode;
  if(openItem.classList.contains("open")) {
    openItem.style.marginBottom =  "0";
    openItem.classList.remove("open");
  } else {
    const opensItem = document.querySelectorAll('.selects-item');
    for(let i = 0; i < opensItem.length; i++){
      if(opensItem[i].classList.contains("open")) {
        opensItem[i].style.marginBottom =  "0";
        opensItem[i].classList.remove("open");
      }
    }
    openItem.classList.add("open");
    const openDetail = document.querySelectorAll('.selects-item.open .selects-item__detail');
    const openDetailHeight = openDetail[0].clientHeight + 32;
    openItem.style.marginBottom = openDetailHeight + "px";
  }
}

const closeSelect = (e) => {
  const openItem = e.currentTarget.closest('.selects-item');
  openItem.classList.remove('open');
}

const closeBtnSelect = (e) => {
  const openItem = e.currentTarget.closest('.selects-item');
  openItem.classList.remove('open');
}

export { openSelect, closeSelect, closeBtnSelect };